import { Module } from 'vuex';
import { state } from './state';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { AuthState } from './types';
import { RootState } from "@/store/modules/general/types";

const namespaced = true;

type AuthModule = Module<AuthState, RootState>;

export const auth: AuthModule = {
    namespaced,
    state,
    actions,
    getters,
    mutations,
}